const rankingItems = [
  { rank: 1, title: '某顶流女星与经纪公司解约内幕全程曝光', tag: '娱乐圈', heat: '9.8万', trend: 'up' },
  { rank: 2, title: '知名导演新片选角潜规则录音流出', tag: '影视圈', heat: '8.6万', trend: 'up' },
  { rank: 3, title: '某地官商勾结土地交易证据链完整公开', tag: '社会热点', heat: '7.9万', trend: 'up' },
  { rank: 4, title: '头部电商平台假货产业链调查报告', tag: '电商圈', heat: '7.2万', trend: 'stable' },
  { rank: 5, title: '某男团队内霸凌视频片段引发粉丝抗议', tag: '娱乐圈', heat: '6.5万', trend: 'down' },
  { rank: 6, title: '知名餐饮连锁品牌后厨卫生黑幕实拍', tag: '食品安全', heat: '5.8万', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">黑料热榜</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">实时追踪全网黑料热度，关注度最高的爆料内容一览</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-3.5 border-b border-background-200/50 last:border-0 hover:bg-background-50/60 px-3 rounded-lg transition-colors cursor-pointer group"
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-sm font-black ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200/70 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h3>
              </div>

              <span className="px-2 py-0.5 bg-background-200/70 text-foreground-500 text-xs rounded-md flex-shrink-0">
                {item.tag}
              </span>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                <i
                  className={`${
                    item.trend === 'up' ? 'ri-arrow-up-line' : item.trend === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'
                  } text-xs ${
                    item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-accent-500' : 'text-foreground-400'
                  }`}
                />
                <span className="text-xs font-medium text-foreground-600 w-12 text-right">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}